export default {
  edit: {
    attributes: [
      {attribute: "currencyCode"},
      {attribute: "name", translated: true}
    ]
  }
}
